import getAssetTypeName from './getAssetTypeName';

export default getAssetTypeName;
